var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00fca3",
    d: "M11.478 32V17.404h4.897l.735-5.69h-5.632V8.082c0-1.647.456-2.769 2.82-2.769l3.01-.001V.223C16.787.155 15 0 12.92 0 8.577 0 5.603 2.651 5.603 7.519v4.196H.691v5.69h4.912V32z"
  })));
};
export default SvgFacebook;